<div class="surgical-safety-checklist-dialog">
    <div class="checklist-info-container">
        <div class="detail-container">
            <div class="header">Surgical Safety Checklist</div>
            <div class="description">Completion of this form is mandatory</div>
        </div>

        <div class="info-grid">
            <app-info-container *ngFor="let container of infoContainers" [mainIcon]="container.mainIcon"
                [headerText]="container.headerText" [subtitleText]="container.subtitleText"
                [actionIcons]="container.actionIcons" [isAddType]="container.isAddType"
                (actionClicked)="onInfoContainerAction($event)">
            </app-info-container>
        </div>
    </div>

    <div class="progress-section">
        <app-block-progress-bar [completedQValue]="completedStep" [selectedValue]="selectedStep" [maxValue]="totalSteps"
            [showLabel]="false" [blockCount]="totalSteps">
        </app-block-progress-bar>
    </div>

    <div class="questionnaire-container">
        <div class="question">{{ currentQuestion }}</div>

        <div class="question-options single-selection" *ngIf="isStandardButtonQuestion()">
            <button *ngFor="let option of currentQuestionOptions" class="single-option-button"
                [class.selected]="isOptionSelected(option)" [disabled]="isSaving" (click)="selectOption(option)">
                {{ option }}
            </button>
        </div>

        <div class="question-options radio-options" *ngIf="isRadioButtonQuestion()">
            <label *ngFor="let option of currentQuestionOptions" class="radio-option">
                <div class="custom-radio">
                    <input type="radio" [name]="'question-' + currentQuestionId" [checked]="isOptionSelected(option)"
                        [disabled]="isSaving" (change)="selectRadioOption(option)">
                    <span class="radiomark"></span>
                </div>
                <span class="radio-label">{{ option }}</span>
            </label>
        </div>

        <div class="question-options checkbox-options" *ngIf="isMultipleSelectionQuestion()">
            <label *ngFor="let option of currentQuestionOptions" class="checkbox-option">
                <div class="custom-checkbox">
                    <input type="checkbox" [checked]="isOptionSelected(option)"
                        [disabled]="isSaving" (change)="toggleMultipleOption(option, $event)">
                    <span class="checkmark"></span>
                </div>
                <span class="checkbox-label">{{ option }}</span>
            </label>
        </div>

        <div class="previous-button-container" *ngIf="selectedStep > 1">
            <button class="outlined-button" [disabled]="isSaving" (click)="previousQuestion()">
                <mat-icon>arrow_back_ios</mat-icon>
                <span>PREVIOUS QUESTION</span>
            </button>
        </div>
        <div class="button-container">
            <button class="outlined-button" [disabled]="isSaving" (click)="saveChecklist()">
                <mat-icon>check</mat-icon>
                <span>SAVE & CLOSE CHECKLIST</span>
            </button>
            <button class="outlined-button" [disabled]="isSaving" (click)="nextQuestion()" *ngIf="selectedStep < totalSteps">
                <span>NEXT QUESTION</span>
                <mat-icon>arrow_forward_ios</mat-icon>
            </button>
        </div>
    </div>
</div>